// eslint-disable-next-line
import { FC, memo, useRef, useEffect } from 'react';
// Hooks
import { usePlayBox5000 } from 'hooks/organisms/playBox/usePlayBox5000';
// Components
import PlayBoxWrap from 'components/organisms/top/playBox/PlayBoxWrap';
// Recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { playBoxShowState } from 'store/atoms/playBoxShowState';
// Utils
import { PLAYBOX_TYPE, PLAYBOX_ID } from 'utils/const/playBox';
// Images
import dayLottsIcon from 'assets/images/top/playBox/daylotts5000_icon.svg';

// id
const { ID_5000 } = PLAYBOX_ID;

/**
 *
 * Component
 *
 */
// PLAYBOX5000用コンポーネント
const PlayBox5000: FC = memo(() => {
  // Recoil
  // PLAYBOX開閉情報更新関数
  const setPlayBoxShow = useSetRecoilState(playBoxShowState);
  // playbox開閉状態
  const playBoxShow = useRecoilValue(playBoxShowState);

  // このコンポーネントのplaybox情報
  const { initialBoxId, isShow5000 } = playBoxShow;
  // PLAYBOX用カスタムフック(個別)
  const { scrollToBox, onClickShow } = usePlayBox5000();

  const boxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // モーダルメニューからの遷移
    if (initialBoxId === ID_5000) {
      setPlayBoxShow({
        initialBoxId: playBoxShow.initialBoxId,
        isShow1000: false,
        isShow5000: true,
        isShow10000: false,
        isShow100000: false,
        isShow1000000: false,
      });

      window.setTimeout(() => {
        // スクロール
        scrollToBox(boxRef);
      }, 500);
    }
  }, [initialBoxId]);

  return (
    <PlayBoxWrap
      type={PLAYBOX_TYPE.BOX_5000}
      id={ID_5000}
      isShow={isShow5000}
      icon={dayLottsIcon}
      _ref={boxRef}
      onClickMethod={onClickShow}
    />
  );
});

export default PlayBox5000;
